module.exports = __webpack_public_path__ + "img/market-position.e18f9df5.png";